import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const authService = {
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.LOGIN}`, {
        email,
        password
      });

      if (response.data.access_token) {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        // Store permissions as stringified array, fallback to empty array if null
        const perms = response.data.user.permissions || [];
        localStorage.setItem('permissions', JSON.stringify(perms));
      }

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  logout: async () => {
    try {
      // Make logout API call if needed
      await axios.post(`${API_BASE_URL}${API_URLS.LOGOUT}`, {}, {
        headers: {
          Authorization: `Bearer ${authService.getToken()}`
        }
      });
    } catch (error) {
      // Even if the API call fails, we should still clear local storage
      console.error('Logout API error:', error);
    } finally {
      // Always clear local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
    }
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  getToken: () => {
    return localStorage.getItem('access_token');
  },

  getPermissions: () => {
    const permissions = localStorage.getItem('permissions');
    try {
      if (!permissions) return [];
      
      let parsed = JSON.parse(permissions);
      
      // If it was double-stringified, parse it again
      if (typeof parsed === 'string') {
        try {
          parsed = JSON.parse(parsed);
        } catch (e) {
          // If it can't be parsed again, it might just be a string that isn't JSON
          return [];
        }
      }
      
      if (!Array.isArray(parsed)) return [];
      
      // Ensure all permissions are integers so strict equality checks work
      return parsed.map(p => parseInt(p, 10)).filter(p => !isNaN(p));
    } catch (error) {
      console.error('Error parsing permissions:', error);
      return [];
    }
  },

  hasPermission: (permissionId) => {
    const permissions = authService.getPermissions();
    return permissions.includes(parseInt(permissionId));
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  }
};

// Axios interceptor to add token to requests
axios.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default authService;